import { render, staticRenderFns } from "./Hauptspeise.vue?vue&type=template&id=1d84282b&scoped=true"
import script from "./Hauptspeise.vue?vue&type=script&lang=js"
export * from "./Hauptspeise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84282b",
  null
  
)

export default component.exports